import css from './admin.module.scss';

import { memo } from 'react';
import { Route, Routes } from 'react-router-dom';

import { getAdminUrl } from 'core/paths';
import Button from 'core/ui/Button';
import { FrameHeader } from 'core/ui/Frame';

import Users from './users/Users';

const Admin = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminPage />} />
      <Route path="/users" element={<Users />} />
    </Routes>
  );
};

const AdminPage = () => {
  return (
    <>
      <FrameHeader>Admin Page</FrameHeader>
      <div className={css.subPages}>
        <SubPage title="Users" link={getAdminUrl('users')}></SubPage>
      </div>
    </>
  );
};

export default memo(Admin);

const SubPage = ({ title, link }: { title: string; link: string }) => (
  <div className={css.subPage}>
    <h3 className={css.subPageTitle}>{title}</h3>
    <div className={css.subPageActions}>
      <Button link={link}>Open</Button>
    </div>
  </div>
);
